import { NumberField, OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import { BaseReportingHistoricalTableModel } from '@/data/models/domain/reporting/common/types'

@OrmModel(modelNames.REPORTING_CALL)
export default class ReportingCall extends BaseReportingHistoricalTableModel {
  @NumberField()
  public callsCount: number

  @NumberField()
  public callsDuration: number

  @NumberField()
  public callsCosts: number
}
